export type SettingsTabId = "overview" | "display" | "accounts" | "gateway" | "capabilities" | "providers" | "fees";
export const SETTINGS_TABS: readonly SettingsTabId[] = Object.freeze([
	"overview",
	"accounts",
	"display",
	"gateway",
	"capabilities",
	"providers",
	"fees",
]);
